<template>
  <div class="random-cases-section" v-if="randomCases.length">
    <div class="wrapper">
      <div class="section">
        <div class="slider-header">
          <div class="left">
            <div class="bottom">
              <h2 class="slider-title">{{ $t('Ultimate StormBills offers') }}</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="random-cases-slider" @click="handleClick">
        <Carousel
            ref="carousel"
            :itemsToShow="itemsToShow"
            :wrapAround="false"
            :snapAlign="'start'"
            :transition="300"
            :breakpoints="breakpoints"
            @slide-end="handleSwipe"
            class="slider products"
        >
          <Slide
              v-for="(card, index) in randomCases"
              :key="card.slug || index"
              class="item card"
              :data-slug="card.slug"
          >
            <div class="card-wrapper" :class="card.type">
              <div class="card-content">
                <div class="card-image-container">
                  <img :src="card.image" :alt="card.name" class="card-image" />
                </div>
                <div class="card-footer">
                  <h3 class="card-title">{{ card.name }}</h3>
                  <p class="card-description">{{ card.description }}</p>
                </div>
                <div class="card-price">{{ card.price }} {{ currencySymbol }}</div>
              </div>
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'RandomCasesSlider',
  components: {
    Carousel,
    Slide,
  },
  inject: ['openSignInModal'],
  data() {
    return {
      randomCases: [],
      sliderIsClickble: true,
      itemsToShow: 4, // начальное значение
      breakpoints: {
        1440: { itemsToShow: 4 },
        1200: { itemsToShow: 3 },
        992: { itemsToShow: 2 },
        600: { itemsToShow: 1 },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['currencySymbol', 'currency']),
  },
  watch: {
    currency() {
      this.fetchRandomCases();
    },
  },
  mounted() {
    this.fetchRandomCases();
    window.addEventListener('resize', this.updateItemsToShow);
    this.updateItemsToShow();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateItemsToShow);
  },
  methods: {
    updateItemsToShow() {
      const width = window.innerWidth;
      if (width >= 1440) this.itemsToShow = 4;
      else if (width >= 1200) this.itemsToShow = 3;
      else if (width >= 992) this.itemsToShow = 2;
      else this.itemsToShow = 1;
    },
    handleSwipe() {
      this.sliderIsClickble = false;
      setTimeout(() => {
        this.sliderIsClickble = true;
      }, 300);
    },
    handleClick(event) {
      if (!this.sliderIsClickble) return;
      const card = event.target.closest('.card');
      if (card) {
        const slug = card.dataset.slug;
        this.$router.push(`/coin-bundles/${slug}`);
      }
    },
    async fetchRandomCases() {
      try {
        const res = await this.$http.get('coin-bundles');
        if (res.status === 200) {
          this.randomCases = res.data.payload;
        }
      } catch (err) {
        if (err.response?.status === 401) {
          this.openSignInModal();
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "vue3-carousel/dist/carousel.css";

.random-cases-section {
  margin-top: 100px;

  .slider-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    line-height: 65px;
    margin-bottom: 40px;

    .left {
      .bottom {
        display: flex;
        gap: 11px;
      }

      .slider-title {
        font-size: calc(clamp(1rem, 0.1429rem + 4.2857vw, 4rem));
        color: #070707;
        font-weight: 700;
      }
    }
  }
}

.random-cases-slider {
  height: 353px;
}

.card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 280px;
  height: 353px;
  position: relative;
  transition: all 0.15s ease;
  margin: 0 12px;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
}

.card-wrapper .card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-price {
  max-width: 110px;
  width: 100%;
  height: 48px;
  background: #1b9b65;
  color: white;
  border-radius: 16px;
  z-index: 2;
  padding: 12px 5px;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-image-container {
  position: relative;
  width: 180px;
  height: 180px;
  pointer-events: none;
  margin-bottom: 12px;
}

.card-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}

.card-image {
  position: relative;
  z-index: 1;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 4px;
  color: #070707;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  text-align: center;
}

.card-description {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  height: 18px;
  color: #070707;
  text-align: center;
  max-width: 160px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
